module.exports = __webpack_public_path__ + "static/looping-white-c1749f93ccf556cda72f6d7f14e41f73.mp4";